import { isString } from "lodash";
/**
 * Languages tags have a primary sub-code that identifies the language: en / fr
 * And an optional sub-code that identifies the national variety in capital letters: GB / FR
 * @todo this will work for time being, Zoltan will change things on identity to support the standards
 */
var transformLocale = function (locale) {
    var _a = locale.split("-"), language = _a[0], nationalVariety = _a[1];
    if (!isString(nationalVariety)) {
        return language;
    }
    return language + "-" + nationalVariety.toUpperCase();
};
export default transformLocale;
